import React, { useState, useEffect } from 'react';
import Layout from '../Layout';
import { Container, Box, Grid, Divider, Button, TextField, Select, MenuItem } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import WebcamCapture from '../Preventive Maintenance/WebcamCapture';
import { CreatePVLogs, getLogByPlanId, PVuploadFile } from '../../ReduxStore/CreatePlanSlice';
import { getAssetDataById } from '../../ReduxStore/MastertableSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';


const CheckPointVerification = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
        { label: 'Plan Overview', href: '/physical-verification/plan-overview' },
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const plan_id = pathname[3];
    const asset_id = pathname[4];
    // const asset_id = pathname[4].replace(/-/g, '');

    const supplier_id = pathname[5];
    const plan_date = pathname[6];

    const [loading, setLoading] = useState(true);
    const [assetDetails, setAssetDetails] = useState(true);
    const [showWebcam, setShowWebcam] = useState(false);
    // const [capturedImage, setCapturedImage] = useState(null);
    const [submitAllOk, setSubmitAllOk] = useState(true);
    const [checkpoints, setCheckpoints] = useState([]);
    const [imageLocation, setLocation] = useState(null);
    const [defaultCheckpoints, setDefaultCheckpoints] = useState([]);
    const [doneBy, setDoneBy] = useState("");
    const [observation, setObservation] = useState("");
    const [uploadedImgUrl, setUploadedImgUrl] = useState(null);
    const [fileName, setFileName] = useState("");
    const [showUploadedImage, setshowUploadedImage] = useState(false);
    const [GoogleMapsUrl, setGoogleMapsUrl] = useState();
    const [DBlocationUrl, setDBLocationUrl] = useState('');
    const [imageUrls, setImageUrls] = useState([]);

    const [checkpointActivityDone, setCheckpointActivityDone] = useState(false);


    const handleCapture = async (imageSrc) => {
        // setCapturedImage(imageSrc);s
        setShowWebcam(false);
        console.log("imge", imageSrc)
        const dataURItoBlob = (dataURI) => {
            const byteString = atob(dataURI.split(',')[1]);
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ab], { type: mimeString });
        };
        const file = dataURItoBlob(imageSrc)
        const customerID = "30fa3d2e687748999daf40a5a9176e4c"
        const formData = new FormData();
        formData.append('upload_file', file);
        formData.append('customerID', customerID)
        // formData.append('file', file);
        try {
            const action = dispatch(PVuploadFile(formData));
            const res = await action.unwrap();
            console.log("res from pv log:", res);
            if (res.StatusCode === 200) {
                setshowUploadedImage(true);
                toast.success("Image Upload Done");
                setUploadedImgUrl(res.response.s3_file_url);
                setFileName(res.response.file_name);
                // console.log("imageURL", uploadedImgUrl, fileName)
            } else {
                toast.error("Something went wrong!")
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const [changedCheckpoints, setChangedCheckpoints] = useState([]);

    const handleStatusChange = (item, status) => {
        const updatedCheckpoints = defaultCheckpoints.map(cp =>
            cp.checkpoint_id === item.checkpoint_id ? { ...cp, status, ok: status === 'OK' } : cp
        );

        setDefaultCheckpoints(updatedCheckpoints);

        // Add or update the checkpoint in the changedCheckpoints array
        const updatedChangedCheckpoints = updatedCheckpoints.filter(cp => cp.checkpoint_id === item.checkpoint_id);
        setChangedCheckpoints(prev => [...prev.filter(cp => cp.checkpoint_id !== item.checkpoint_id), ...updatedChangedCheckpoints]);
    };


    const submitHandler = async () => {
        setshowUploadedImage(false);
        // Check if fileName is present
        // if (!fileName) {
        //     toast.error("Please click the asset picture.");
        //     return; // Exit the function if fileName is not present
        // }

        // Check if doneBy is present
        if (!doneBy) {
            toast.error("Please enter 'Done By'.");
            return; // Exit the function if doneBy is empty
        }

        // Check if observation is present
        if (!observation) {
            toast.error("Please enter an observation.");
            return; // Exit the function if observation is empty
        }

        const checkpointData = changedCheckpoints.map(cp => ({
            id: cp.checkpoint_id,
            ok: cp.status === 'OK'
        }));

        const log_data = {
            plan_id,
            asset_id,
            supplier_id,
            done_by: doneBy,
            current_location: "pune",
            current_location_url: GoogleMapsUrl,
            object_ids: fileName ? [fileName] : [],
            observation,
            checkpoints: checkpointData
        };
        console.log("PAYLOAD:", log_data);
        try {
            const action = dispatch(CreatePVLogs(log_data));
            const res = await action.unwrap();
            console.log("res from pv log:", res);
            if (res.StatusCode === 201) {
                toast.success("Checkpoint Done");
                getlogs();
            } else {
                toast.error("Something went wrong!")
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Failed to create PV log!");
        }

    };

    // const getCheckpoints = async () => {
    //     const action = dispatch(getDefaultCheckpoints(plan_id));
    //     const res = await action.unwrap();
    //     // setDefaultCheckpoints(res.result.pv_checkpoints);
    // };


    const getlogs = async () => {
        try {
            const action = dispatch(getLogByPlanId(`?plan_id=${plan_id}&plan_date=${plan_date}&asset_id=${asset_id}`));
            const res = await action.unwrap();
            console.log("log response:", res);
            setDefaultCheckpoints(res.result.pv_logs);

            // Check if all logs have the 'point_ok' property
            const allLogsHavePointOk = res.result.pv_logs.every(log => log.hasOwnProperty('point_ok'));

            // If all logs have 'point_ok', set checkpoint activity as done
            if (allLogsHavePointOk) {
                setCheckpointActivityDone(true);
            } else {
                setCheckpointActivityDone(false);
            }


            const allUrls = res.result.pv_logs
                .map(log => log.all_URLs)
                .flat() // Flatten the array if there are nested arrays
                .filter(url => typeof url === 'string');
            console.log("All url:", allUrls)

            // Use a Set to store unique URLs only
            const uniqueUrls = [...new Set(allUrls)];
            console.log("All unique URLs:", uniqueUrls);

            if (uniqueUrls.length > 0) {
                console.log("Check unique URLs:", uniqueUrls);
                setImageUrls(uniqueUrls);
                setshowUploadedImage(true);
            }
            // if (allUrls.length > 0) {
            //     console.log("check urls--------", allUrls)
            //     setImageUrls(allUrls);
            //     setshowUploadedImage(true);
            // }
            if (res && res.result && Array.isArray(res.result.pv_logs)) {
                // Sort the logs by time to get the latest one
                const sortedLogs = res.result.pv_logs.sort((a, b) => new Date(b.log_time) - new Date(a.log_time));
                console.log("sortedLogs", sortedLogs)
                // Get the latest log
                const latestLog = sortedLogs[0];
                console.log("latestLog", GoogleMapsUrl)

                // Use current_location_url if available, otherwise generate a Google Maps URL
                const url = latestLog.current_location_url || GoogleMapsUrl;
                setDBLocationUrl(url);
                console.log("URL:", url)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Failed to create PM log!");
        }

    };

    const getAssetById = async () => {
        try {
            const action = dispatch(getAssetDataById(asset_id));
            // const action = dispatch(getMasterTableData(`?asset_id=${asset_id}`));
            const res = await action.unwrap();
            setAssetDetails(res.result)
        } catch (error) {
            console.log("hey i am error:", error)
            toast.error(error.message);
        }
    }


    const getLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                console.log("Location", latitude, longitude);

                // Set the location state
                setLocation({
                    latitude: latitude,
                    longitude: longitude
                });

                // Generate the Google Maps URL
                const googleMapsUrl = `https://maps.google.com/?q=${latitude},${longitude}`;
                console.log("Google Maps URL:", googleMapsUrl);
                setGoogleMapsUrl(googleMapsUrl)
                // Optionally, you can open the URL in a new tab
                // window.open(googleMapsUrl, "_blank");

                // Show the toast with the clickable link
                // toast.info(
                //     <div>
                //         {/* <h4>Your Location</h4> */}
                //         <p>
                //             <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                //                 Open in Google Maps
                //             </a>
                //         </p>
                //     </div>,
                //     {
                //         // position: toast.POSITION.BOTTOM_CENTER,
                //         position: toast.POSITION.TOP_RIGHT,
                //         autoClose: false,  // Disable auto close to allow user interaction
                //     }
                // );
            });
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };



    useEffect(() => {
        const fetchData = async () => {
            await getLocation();
            // await getCheckpoints();
            await getlogs();
            await getAssetById();
            setLoading(false);
        };
        fetchData();
    }, [plan_id]);



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Checkpoint Activity" />
                </Box>
                <Box mb={2}>
                    <h2>{assetDetails.asset_text} ({(assetDetails.asset_no)?.slice(3)})</h2>
                    <div className="checkpoint-box">
                        <Box className="table-container">
                            <Grid container spacing={1} className="checkpoint-header">
                                <Grid item xs={1} sm={1}>
                                    <h3>Sr.No.</h3>
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    <h3>Checkpoints</h3>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <h3>Status</h3>
                                </Grid>
                                <Grid item xs={2} sm={3}>
                                    <h3>Action</h3>
                                </Grid>
                            </Grid>
                            <Divider />
                            <Box className="table-content">
                                {defaultCheckpoints && defaultCheckpoints.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Grid container spacing={3} className="checkpoint-item">
                                            <Grid item xs={1}>
                                                {index + 1}
                                            </Grid>
                                            <Grid item xs={3} sm={3}>
                                                {item.check_point}
                                            </Grid>
                                            <Grid item xs={2} sm={2}>
                                                {/* {item.status} */}
                                                {item.hasOwnProperty('point_ok')
                                                    ? (item.point_ok ? 'OK' : 'NG')
                                                    : 'Not Done'}
                                            </Grid>
                                            <Grid item xs={2} sm={3}>
                                                <Select
                                                    displayEmpty
                                                    fullWidth
                                                    value={item.status}
                                                    disabled={checkpointActivityDone}
                                                    onChange={(e) => handleStatusChange(item, e.target.value)}
                                                >
                                                    <MenuItem value="OK">OK</MenuItem>
                                                    <MenuItem value="NG">NG</MenuItem>
                                                </Select>
                                            </Grid>
                                        </Grid>
                                        {index < checkpoints.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>
                    </div>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <h3>Location</h3>
                            <h5>Latitude:{imageLocation?.latitude}</h5>
                            <h5>Longitude:{imageLocation?.longitude}</h5>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <h3>Current Location Url:</h3>
                            <a href={DBlocationUrl ? DBlocationUrl : GoogleMapsUrl} target="_blank" rel="noopener noreferrer">
                                {DBlocationUrl ? DBlocationUrl : GoogleMapsUrl}
                            </a>
                        </Grid>
                    </Grid>
                </Box>

                {imageUrls.length === 0 && (
                    <Box className="checkpoint-box" mb={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                Take Pictures
                                <h4>Please specify the checkpoint as OK or NG first</h4>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={3}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => setShowWebcam(true)}
                                    disabled={checkpointActivityDone}
                                >
                                    Start
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                )}
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            Observation
                            <h4>Comment your Observation</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Observation"
                                name="Observation"
                                type="text"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={observation}
                                disabled={checkpointActivityDone}
                                onChange={(e) => setObservation(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {showWebcam && (
                    <Box className='checkpoint-box' mb={2}>
                        <WebcamCapture onCapture={handleCapture} />
                    </Box>
                )}
                {showUploadedImage && (
                    <Box className='checkpoint-box' mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={6}>
                                <h4>Uploaded Images</h4>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            {imageUrls && imageUrls.length > 0 ? (
                                imageUrls.map((url, index) => (
                                    <Grid item xs={6} sm={6} key={index}>
                                        <img src={url} alt={`Uploaded ${index + 1}`} width="100%" />
                                    </Grid>
                                ))
                            ) : (<Grid item xs={6} sm={6}>
                                <img src={uploadedImgUrl} alt="Uploaded" width="100%" />
                            </Grid>
                            )}
                        </Grid>
                    </Box>
                )}
                <Box mb={1}>
                    <div className="checkpoint-box">
                        {/* <Grid container spacing={3}>
                            <Grid item xs={1}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={submitAllOk}
                                            name="enabled"
                                            color="primary"
                                            onClick={() => setSubmitAllOk(!submitAllOk)}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <p>Submit all as Ok</p>
                            </Grid>
                        </Grid> */}
                        <Grid container spacing={3} className='row1'>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Carried Out by"
                                    name="doneBy"
                                    type="text"
                                    size='small'
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={doneBy}
                                    disabled={checkpointActivityDone}
                                    onChange={(e) => setDoneBy(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color='primary'
                                    fullWidth
                                    // disabled={!submitAllOk}
                                    onClick={submitHandler}
                                    disabled={checkpointActivityDone}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Box>
                <div className="btn"></div>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default CheckPointVerification;
